import { render } from "./ManageSDVRule.vue?vue&type=template&id=7007dd66&scoped=true"
import script from "./ManageSDVRule.js?vue&type=script&lang=js"
export * from "./ManageSDVRule.js?vue&type=script&lang=js"

import "./ManageSDVRule.vue?vue&type=style&index=0&id=7007dd66&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7007dd66"]])

export default __exports__